
import React from 'react';

const WhyChooseUs = ({ homeContent }) => {
  return (
    <section className="bg-gray-light p-top-50 p-bottom-35">
      <div className="container">
        <div className="row">
          <div className="col text-center">
            <div className="section_title">
              <h1>Why Choose us</h1>
            </div>
          </div>
        </div>
      </div>

      <div className="process-wrapper section-bg process--two">
        <div className="px-3 px-md-5">
          <div className="row">
            <div className="col-lg-12">
              <div className="process-one">

                {/* Step 1 */}
                <div className="process-single">
                  <div className="icon light-bg">
                    <span className="step">1</span>
                    <span className="icon-la">
                      <i className="la la-sun-o"></i>
                    </span>
                  </div>

                  <h6>Initial Concept</h6>

                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        homeContent?.home_initial_concept ||
                        'Initial concept description',
                    }}
                  />
                </div>

                {/* Step 2 */}
                <div className="process-single">
                  <div className="icon light-bg">
                    <span className="step">2</span>
                    <span className="icon-la">
                      <i className="la la-bar-chart"></i>
                    </span>
                  </div>

                  <h6>Market Analysis</h6>

                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        homeContent?.home_market_analysis ||
                        'Market analysis description',
                    }}
                  />
                </div>

                {/* Step 3 */}
                <div className="process-single">
                  <div className="icon light-bg">
                    <span className="step">3</span>
                    <span className="icon-la">
                      <i className="la la-rocket"></i>
                    </span>
                  </div>

                  <h6>Grow Business</h6>

                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        homeContent?.home_grow_business ||
                        'Business growth description',
                    }}
                  />
                </div>

                {/* Step 4 */}
                <div className="process-single">
                  <div className="icon light-bg">
                    <span className="step">4</span>
                    <span className="icon-la">
                      <i className="la la-headphones"></i>
                    </span>
                  </div>

                  <h6>Fast Support</h6>

                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        homeContent?.home_fast_support ||
                        'Support description',
                    }}
                  />
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;